import { Avatar, Button, Descriptions, List, Segmented, Spin, Table } from "antd";
import Title from "antd/es/typography/Title";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Card from "../../components/Card";
import { PrinterOutlined } from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";

const ViewPromotion = () => {

    const location = useLocation();

    const promotionRef = useRef<any>(null);

    const [promotion, setPromotion] = useState({
        id: null,
        title: null,
        description: null,
        startDate: null,
        endDate: null,
        promotionItems: []
    })

    const handlePrint = useReactToPrint({
        content: () => promotionRef.current,
    });
    

    useEffect(() => {
        if (location.state?.promotion) {
            console.log("order param", location?.state?.order)
            // setUser({ ...location.state.user });
            // location.state.user = null;
            // getUserById(location?.state?.user?.id)
            setPromotion(location?.state?.promotion);

        }
    }, [])

    return (
        <>
            <div className="container">



                <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                    <Title level={4} style={{ fontWeight: '400', fontFamily: 'Source Sans 3' }}>Produktet</Title>


                </div>


                <div className="row">
                    <div className="col-lg-8">
                        <Card title={`Te dhenat e promocionit`} HeaderButton={<><Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
      Print
    </Button></>}>


                            <Descriptions>
                                {/* <Descriptions.Item label="ID">#{promotion?.id}</Descriptions.Item> */}
                                <Descriptions.Item label="Titulli">{promotion?.title}</Descriptions.Item>
                                <Descriptions.Item label="Pershkrimi">{promotion?.description}</Descriptions.Item>
                               

                            </Descriptions>
                            <Descriptions>
                            <Descriptions.Item label="Valide nga">{promotion?.startDate}</Descriptions.Item>
                                <Descriptions.Item label="Valide deri">{promotion?.startDate}</Descriptions.Item>
                            </Descriptions>
                        </Card>
                    </div>
                    <div className="col-lg-8 mt-3">
                        <Card title="Produktet">
                            <List

                                dataSource={promotion?.promotionItems}
                                renderItem={(item, index) => (
                                    <List.Item>
                                        <List.Item.Meta
                                            avatar={
                                                <Avatar style={{ backgroundColor: "orange", verticalAlign: 'middle', textTransform: "uppercase" }} size="large" >
                                                    {item?.productName?.charAt(0)}
                                                </Avatar>
                                            }
                                            title={<Link to={"/articles"}>{item?.productName}</Link>}
                                            description={`${item?.price}€`}
                                        />
                                    </List.Item>
                                )}
                            />
                        </Card>

                        <table ref={promotionRef} className="table table-bordered" id="promotionItemsTable" style={{marginBottom: 0}}>
                            <thead>
                                <tr>
                                    <td colSpan={4}>
                                    <img src="https://ardhmeria-ks.com/b2b/Ardhmeria_emblem.png" className="header-logo" />
                                    </td>
                                </tr>
                                <tr>
                                    <th style={{ width: "25%" }}>
                                        Promocioni
                                    </th>
                                    <td colSpan={3}>{promotion?.title}</td>
                                </tr>
                                <tr>
                                    <th>
                                        Pershkrimi
                                    </th>
                                    <td colSpan={3}>{promotion?.description}</td>
                                </tr>
                                <tr>
                                    <th style={{width: "25%"}}>Valide nga:</th>
                                    <td>{promotion?.startDate}</td>
                                    <th style={{width: "25%"}}>Valide deri:</th>
                                    <td>{promotion?.endDate}</td>
                                </tr>
                                <tr>
                                    <td colSpan={4} style={{backgroundColor: "rgb(245 245 245)", textAlign: "center"}}>
                                        <p className="text-large">Lista e produkteve</p>
                                    </td>
                                </tr>
                                <tr>
                                    <th colSpan={3}>Produkti</th>
                                    <th>Çmimi</th>
                                </tr>
                            </thead>

                            <tbody>
                                {promotion.promotionItems.map((item, index) => (
                                    <tr key={index}>
                                        <td colSpan={3} style={{ width: "50%", backgroundColor: index % 2 == 0 ? "rgb(248 248 248)":"white" }}>{item?.productName}</td>
                                        <td style={{backgroundColor: index % 2 == 0 ? "rgb(248 248 248)":"white" }}>{item?.price}€</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        
                    </div>
                </div>
            </div>


        </>
    )
}

export default ViewPromotion